module.exports = __webpack_public_path__ + "img/table-tab.c4e9442e.svg";